import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'

function About(props) {
  return (
    <section style={{minHeight: '50vh'}} className="overflow-visible bg-light-black text-my-grey">
      <div className="relative px-1 pt-12 pb-12 mx-auto max-w-screen-xl sm:px-6 lg:px-8 lg:py-4">
        <div className="relative lg:flex lg:items-center">
          <div className="hidden lg:block lg:flex-shrink-0">
            <GatsbyImage
              image={props.image}
              className="h-64 rounded-full lg:inline-block xl:h-80"
              alt=""
            />
          </div>
          <div className="flex justify-center flex-shrink-0 transform -translate-x-5 lg:hidden">
            <GatsbyImage image={props.mimage} className="object-cover" alt="" />
          </div>

          <div className="relative lg:ml-10">
            <blockquote className="relative">
              <div className="text-lg md:text-2xl font-normal xs:mx-5 xs:text-left leading-9">
                <p>{props.text}</p>
              </div>
            </blockquote>
          </div>
        </div>
      </div>
    </section>
  )
}

export default About
